export const BANNER_TYPES = {
	Resend: 'resend',
	ReadOnly: 'readonly'
} as const;
